import { isObject } from './../types';
import { camel2UnderScore, underScore2Camel } from './string';
/**
 * 判断Object是否有key属性
 * @category Object
 * @param {obj} 被判断的对象
 * @param {key} 要检查的key属性名
 * @returns {boolean} true: 表示属性存在; false: 属性不存在
 */
export function has(obj, key) {
    return obj !== null && Object.prototype.hasOwnProperty.call(obj, key);
}
export function snakeKeys(obj) {
    if (!obj || !isObject(obj)) {
        return obj;
    }
    var newObj = {};
    var keys = Object.keys(obj);
    keys.forEach(function (key) {
        var underScoreKey = camel2UnderScore(key);
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (Array.isArray(obj[key])) {
                var array = obj[key];
                var newArray_1 = [];
                array.forEach(function (item) {
                    var tempItem = snakeKeys(item);
                    newArray_1.push(tempItem);
                });
                newObj[underScoreKey] = newArray_1;
            }
            else if (obj[key] instanceof Object) {
                newObj[underScoreKey] = snakeKeys(obj[key]);
            }
            else {
                newObj[underScoreKey] = obj[key];
            }
        }
    });
    return newObj;
}
export function camelKeys(obj) {
    if (!obj || !isObject(obj)) {
        return obj;
    }
    var newObj = {};
    var keys = Object.keys(obj);
    keys.forEach(function (key) {
        var camelKey = underScore2Camel(key);
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            // 类型嵌套的情况处理
            if (Array.isArray(obj[key])) {
                var array = obj[key];
                var newArray_2 = [];
                array.forEach(function (item) {
                    var tempItem = camelKeys(item);
                    newArray_2.push(tempItem);
                });
                newObj[camelKey] = newArray_2;
            }
            else if (obj[key] instanceof Object) {
                newObj[camelKey] = camelKeys(obj[key]);
            }
            else {
                newObj[camelKey] = obj[key];
            }
        }
    });
    return newObj;
}
/**
 * 将 Object 属性和静态属性挂载到父对象，优化调用链
 * 旧：this.UserInfoDomainService.UserInfoAggregate.xxx
 * 新：this.UserInfoDomainService.xxx
 * 目前先将 Aggregate 层和 DomainService 层合并，后续统一去除 Aggregate 层
 * @target Object 父对象
 * @source new Object 子对象
 * @source2 Object 子对象
 */
export function mergeAggregate(target, source, source2) {
    Object.getOwnPropertyNames(source).forEach(function (key) {
        var descriptor = Object.getOwnPropertyDescriptor(source, key);
        if (descriptor && key !== 'constructor') {
            Object.defineProperty(target, key, descriptor);
        }
    });
    Object.getOwnPropertyNames(source2.prototype).forEach(function (property) {
        if (property !== 'constructor') {
            target[property] = source2.prototype[property];
        }
    });
}
/**
 *  以下 prepotyUnderScore2Camel、prepotyCamel2UnderScore已停用， 新的直接使用 camelKeys | snakeKeys
 */
export var prepotyUnderScore2Camel = camelKeys;
export var prepotyCamel2UnderScore = snakeKeys;
